import {ClassName, DefaultChildren} from '#/utils/utils';
import {FunctionComponent} from 'react';

export const PortfolioIconTitle: FunctionComponent<
  {
    IconComponent: FunctionComponent<ClassName>;
  } & ClassName &
    DefaultChildren
> = ({IconComponent, children}) => (
  <>
    <IconComponent
      className={
        'w-6 h-6 stroke-transparent fill-white group-data-[state=active]:fill-white group-data-[stepcompleted=true]:fill-upgreen group-data-[state=inactive]:group-data-[stepcompleted=false]:group-hover:fill-white'
      }
    />
    <span className='font-bold text-white text-xl sm:text-xl whitespace-nowrap select-none'>{children}</span>
  </>
);
